import { FC } from 'react';

import {
  Link as BaseLink,
  LinkProps as BaseLinkProps,
} from '@beeline/lk-utils';

import classes from './Link.module.scss';

export interface LinkProps extends BaseLinkProps {
  navigationType?: BaseLinkProps['navigationType'];
}

export const Link: FC<LinkProps> = ({
  children,
  navigationType = 'inner',
  ...rest
}) => {
  return (
    <BaseLink
      navigationType={navigationType}
      className={classes.link}
      data-testid='bookingTitle'
      {...rest}
    >
      {children}
    </BaseLink>
  );
};
